import { useEffect, useState } from "react"
import { io } from 'socket.io-client'
import AuthService from "../../service"
import { useDispatch, useStore } from "react-redux"
import { setLoading } from "../../dashboard/component/loading/store"

export function unidadeDoEvento(cacheKey) {
    const queryString = String(cacheKey || '').split('?')[1]

    if (!queryString) {
        return null
    }

    return new URLSearchParams(queryString).get('unidade')
}

export function ehBuscaAtual(store, cacheKey) {
    const unidadeAtual = store.getState().todaySlices?.unidade
    const unidadeDoResultado = unidadeDoEvento(cacheKey)

    if (!unidadeAtual || !unidadeDoResultado) {
        return true
    }

    return String(unidadeAtual) === String(unidadeDoResultado)
}

export function mesclarComHoje(store, kpiType, result) {
    const cached = Array.isArray(result) ? result : []
    const hoje = store.getState().todaySlices?.recortes?.[kpiType] || []

    return [...cached, ...hoje]
}

export const criarTratadorDeEvento = ({ store, dispatch, service, selectedDate }) => {
    const comHoje = (kpiType, result) => mesclarComHoje(store, kpiType, result)

    const entregas = {
        KPI_SALES: {
            url: '/sales/card',
            loading: 'KPI_SALES',
            acao: (result) => ({ type: 'KPI_SALES', kpiSales: comHoje('KPI_SALES', result), loading: false, selectedDate }),
        },
        KPI_PERFORMANCE_STORE: {
            url: '/performanceStore/list',
            loading: 'KPI_PERFORMANCE_STORE',
            acao: (result) => ({ type: 'KPI_PERFORMANCE_STORE', kpiPerformance: comHoje('KPI_PERFORMANCE_STORE', result), loading: false, selectedDate }),
        },
        KPI_PERFORMANCE_TIME_STATUS: {
            url: '/performanceTimeByStatus/list',
            loading: 'KPI_PERFORMANCE_TIME_STATUS',
            acao: (result) => ({ type: 'KPI_PERFORMANCE_TIME_STATUS', kpiPerformanceTimeBySatus: comHoje('KPI_PERFORMANCE_TIME_STATUS', result), loading: false, selectedDate }),
        },
        KPI_PRODUCT: {
            url: '/product/card',
            loading: 'KPI_PRODUCT',
            acao: (result) => ({ type: 'KPI_PRODUCT', kpiProduct: comHoje('KPI_PRODUCT', result), loading: false, selectedDate }),
        },
        KPI_CUSTOMER: {
            url: '/customer/card',
            loading: 'KPI_CUSTOMER',
            acao: (result) => ({ type: 'KPI_CUSTOMER', kpiCustomer: { listAllSalesCustomer: comHoje('KPI_CUSTOMER', result), loading: false, selectedDate } }),
        },
        KPI_CHECKING: {
            url: '/checking/list',
            loading: 'KPI_CHECKING',
            acao: (result) => ({ type: 'KPI_CHECKING', kpiChecking: comHoje('KPI_CHECKING', result), selectedDate }),
        },
        KPI_ORDER_INTEGRATION: {
            url: '/orderIntegration/listOrderIntegration',
            loading: 'KPI_ORDER_INTEGRATION',
            acao: (result) => ({ type: 'KPI_ORDER_INTEGRATION', kpiOrderIntegration: comHoje('KPI_ORDER_INTEGRATION', result), selectedDate }),
        },
        KPI_PAYMENT_EXCLUSION: {
            url: '/paymentExclusion/list',
            loading: 'KPI_PAYMENT_EXCLUSION',
            acao: (result) => ({ type: 'KPI_PAYMENT_EXCLUSION', kpiPaymentExclusion: comHoje('KPI_PAYMENT_EXCLUSION', result), selectedDate }),
        },
        KPI_TODAY: {
            url: '/realtime/today',
            loading: 'KPI_REALTIME_TODAY',
            acao: (result) => ({ type: 'KPI_REALTIME', kpiToday: result, selectedDate }),
        },
        KPI_REALTIME: {
            url: '/realtime/realtime',
            loading: 'KPI_REALTIME',
            acao: (result) => ({ type: 'KPI_REALTIME', kpiRealTime: result, selectedDate }),
        },
        KPI_TIME_METRICS: {
            url: '/realtime/time-metrics',
            loading: 'KPI_TIME_METRICS',
            acao: (result) => ({ type: 'KPI_REALTIME', kpiTimeMetrics: result, selectedDate }),
        },
        KPI_IDENTIFIER: {
            url: '/settings/identificador',
            loading: 'KPI_IDENTIFIER',
            acao: (result) => ({ type: 'KPI_REALTIME', listIdentifier: result, selectedDate }),
        },
    }

    return function onMessageReceive(event) {
        const entrega = entregas[event?.type]

        if (!entrega || event.data?.status !== "FINISH") {
            return
        }

        const cacheKey = event.data.cacheKey

        if (!ehBuscaAtual(store, cacheKey)) {
            console.warn(`Resultado de busca superada ignorado (${event.type})`)
            return
        }

        return service.get(entrega.url, { cacheKey })
            .then(result => {
                if (!ehBuscaAtual(store, cacheKey)) {
                    console.warn(`Busca superada durante a entrega, resultado descartado (${event.type})`)
                    return
                }

                dispatch(entrega.acao(result))
            })
            .finally(() => {
                if (ehBuscaAtual(store, cacheKey)) {
                    dispatch(setLoading(entrega.loading, false))
                }
            })
    }
}

export function useSocket(selectedDate) {
    const [socket, setSocket] = useState(null)
    const [anotherLoading, setAnotherLoading] = useState(false)
    const dispatch = useDispatch()
    const store = useStore()
    const service = new AuthService()

    useEffect(() => {
        function initSocket() {
            if (socket) return

            const room_socket = AuthService.getToken() + '_BI' + process.env.REACT_APP_SOCKET_ROOM
            const query = 'room=' + room_socket + '&auth=' + process.env.REACT_APP_WEBSOCKET_AUTH_TOKEN
            const webSocket = io(process.env.REACT_APP_SOCKET_URL, {
                query,
                transports: ['websocket']
            })

            console.log('Socket instanciado', webSocket)

            webSocket.on("connect", () => {
                console.log('Connect SocketIO', webSocket.id)
            })

            webSocket.on("disconnect", (msg) => {
                console.log('Disconnect SocketIO', webSocket.id)
                console.log("Disconnection message", msg)
            })

            setSocket(webSocket)
        }

        initSocket()

        return () => {
            if (socket) socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (!socket) return

        const onMessageReceive = criarTratadorDeEvento({ store, dispatch, service, selectedDate })

        socket.on('Update', onMessageReceive)

        socket.on('reciveSocketMessage', onMessageReceive)

        return () => {
            socket.off('Update', onMessageReceive)

            socket.off('reciveSocketMessage', onMessageReceive)
        }
    }, [socket, selectedDate, store])

    return [anotherLoading, setAnotherLoading]
}
